// extracted by css-extract-rspack-plugin
export default {"list":"SpecifiedWorks__list--lXYCv","listItem":"SpecifiedWorks__listItem--VUQJP"};